import React, { useState, useEffect, useContext } from 'react';
import './business-account-details.scss';
import { default as t } from '../../../../utils/i18n';
import { ReactComponent as EditIcon } from '../../../../assets/svg/edit.svg';
import { ReactComponent as SaveIcon } from '../../../../assets/svg/save.svg';
import { Button, DateRangePicker } from 'rsuite';
import { ActionLink, ModalWindow, Dropdown } from '../../../atoms';
import queryString from 'query-string';
import { AdminService, DashService } from '../../../../services';
import { UserContext, FilterContext } from '../../../../context';
import { ActiveAccounts } from '../../molecules';
import subDays from 'date-fns/subDays';
import InputGroup from 'rsuite/InputGroup';
import { DatePicker } from 'rsuite';
import html2canvas from 'html2canvas';
import jsPdf from "jspdf";
import fileDownload from 'js-file-download';
import { ReactComponent as DownloadIcon } from '../../../../assets/svg/Download-icon.svg';

const BusinessAccountDetails = props => {
  const location = queryString?.parse(window.location.search);
  const accountId = location?.accountId;
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [accountDetails, setAccountDetails] = useState([]);
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const [businessNameEdit, setBusinameEdit] = useState(false);
  const [businessTokenEdit, setBusinessTokenEdit] = useState(false);
  const [editedDetails, seteditedDetails] = useState({});
  const [showDeboardModal, setShowDeboardModal] = useState(false);
  const [usuageDetails, setUsuageDetails] = useState(null);
  const [usuageData, setUsuageData] = useState([]);
  const [diagnosticsDetails, setDiagnosticsDetails] = useState([]);
  const [viewDetails, setViewDetails] = useState(null);
  const { allowedRange } = DateRangePicker;
  const { filterDetails, setFilterDetails } = useContext(FilterContext);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisable, setStartDateDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [freq, setFreq] = useState('');

  const predefinedRanges = [
    {
      label: 'Last 30 days',
      value: [subDays(new Date(), 29), new Date()],
      placement: 'left',
    },
    {
      label: 'Last 60 days',
      value: [subDays(new Date(), 59), new Date()],
      placement: 'left',
    },
    {
      label: 'Last 90 days',
      value: [subDays(new Date(), 89), new Date()],
      placement: 'left',
    },
    {
      label: 'Custom',
      value: 'custom',
    },
  ];

  const handleBackClick = e => {
    props.handleBackClick(e);
  };

  useEffect(() => {
    setFreq(predefinedRanges[0]);
    getAccountDetails();
    handleDateRange(predefinedRanges[0].value);
    setEndDateDisable(false);
    getCountryList();
    getIndustryList();
    getSubVerticalList();
    getAllAdvertiser();
  }, []);

  async function getCountryList() {
    try {
      const countryListResponse = await DashService.countryList(userAccessToken, username);
      const countryList = countryListResponse.data?.data?.map(res => ({
        value: res.country_code,
        label: res.name,
      }));
      setFilterDetails(prevDashData => ({
        ...prevDashData,
        countryList: [...countryList],
      }));
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getIndustryList() {
    try {
      const industryListResponse = await DashService.industryList(userAccessToken, username);
      const industryList = industryListResponse.data?.data?.map(res => ({
        value: res.name,
        label: res.name,
      }));
      setFilterDetails(detail => ({
        ...detail,
        industryList: [...industryList],
      }));
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getSubVerticalList() {
    try {
      const listResponse = await DashService.subVerticalList(userAccessToken, username);
      const verticalListRes = listResponse.data?.data?.map(res => ({
        value: res.name,
        label: res.name,
      }));
      setFilterDetails(detail => ({
        ...detail,
        verticalList: [...verticalListRes],
      }));
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const getAllAdvertiser = async () => {
    try {
      const response = await DashService.advertiserList(userAccessToken, username);
      let adverseList = response.data?.data?.map(advertiser => ({
        value: advertiser,
        label: advertiser,
      }));
      setFilterDetails(detail => ({
        ...detail,
        advertiserList: [...adverseList],
      }));
    } catch (error) {}
  };

  async function getAccountDetails() {
    try {
      const bmResponse = await AdminService.getBusinessAccountDetails(
        userAccessToken,
        username,
        accountId
      );
      let acResponse = { ...bmResponse?.data?.data };
      acResponse.businessUsersSync.nextSync = getTime({
        lastAttemptedAt: acResponse.businessUsersSync.lastAttemptedAt,
        syncInterval: acResponse?.businessUsersSync?.syncInterval,
      });
      acResponse.ownedAccountSync.nextSync = getTime({
        lastAttemptedAt: acResponse?.ownedAccountSync?.lastAttemptedAt,
        syncInterval: acResponse?.ownedAccountSync?.syncInterval,
      });
      acResponse.clientAccountSync.nextSync = getTime({
        lastAttemptedAt: acResponse.clientAccountSync.lastAttemptedAt,
        syncInterval: acResponse?.clientAccountSync?.syncInterval,
      });
      let diagnostics = [
        {
          label: t('admin.bm.details.last.owned'),
          status: acResponse?.businessUsersSync?.status,
          nextSync: acResponse.businessUsersSync.nextSync,
        },
        {
          label: t('admin.bm.details.last.clients.sync'),
          status: acResponse?.ownedAccountSync?.status,
          nextSync: acResponse.ownedAccountSync.nextSync,
        },
        {
          label: t('admin.bm.details.last.business.sync'),
          status: acResponse?.clientAccountSync?.status,
          nextSync: acResponse.clientAccountSync.nextSync,
        },
      ];
      setDiagnosticsDetails([...diagnostics]);
      setAccountDetails(acResponse);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const getTime = value => {
    const date = new Date(value.lastAttemptedAt + value.syncInterval);
    return date.toLocaleString();
  };

  const handleOpenSliderModal = (val, isAdded) => {
    setOpenSliderModal(!openSliderModal);
  };

  const onViewAccounts = (e, pageView) => {
    e.preventDefault();
    setViewDetails(pageView);
    setOpenSliderModal(true);
  };

  const handleDateRange = date => {
    setStartDate(new Date(date[0]));
    setEndDate(new Date(date[1]));
    let startDate = updateDateFormatApi(date[0]);
    let endDate = updateDateFormatApi(date[1]);
    getUsuageDetailsBasedOnFreq(startDate, endDate);
  };

  const updateDateFormatApi = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1;
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return yyyy + '-' + mm + '-' + dd;
  };

  async function getUsuageDetailsBasedOnFreq(startDate, endDate) {
    try {
      const ususgeRes = await AdminService.getUsageDetails(
        userAccessToken,
        username,
        'businessaccount',
        accountId,
        startDate,
        endDate
      );
      let reultRes = ususgeRes?.data?.data;
      let ususgeVal = [
        {
          label: t('admin.bm.details.campaign.insights'),
          result: `${reultRes?.scheduledCampaignInsights}/${reultRes?.deliveredCampaignInsights}`,
        },
        {
          label: t('admin.bm.details.optmi'),
          result: `${reultRes?.scheduledCampaignOptimizationAnalysis}/${reultRes?.deliveredCampaignOptimizationAnalysis}`,
        },
        {
          label: t('admin.bm.details.eocr'),
          result: `${reultRes?.scheduledEOCRReports}/${reultRes?.deliveredEOCRReports}`,
        },
        {
          label: t('admin.bm.details.pca'),
          result: `${reultRes?.scheduledPCAReports}/${reultRes?.deliveredPCAReports}`,
        },
        {
          label: t('admin.bm.details.Scheduled'),
          result: `${reultRes?.scheduledLiveReports}/${reultRes?.deliveredLiveReports}`,
        },
      ];
      setUsuageData([...ususgeVal]);
      setUsuageDetails({ ...reultRes });
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const onClickOfEdit = clickedVal => {
    if (clickedVal === '1') {
      setBusinameEdit(true);
    } else {
      setBusinessTokenEdit(true);
    }
    seteditedDetails({
      ...editedDetails,
      businessName: accountDetails.businessName,
      token: accountDetails.token,
    });
  };

  const onClickOfSave = clickedVal => {
    if (clickedVal === '1') {
      accountDetails.businessName = editedDetails?.businessName;
      setBusinameEdit(false);
    } else {
      accountDetails.token = editedDetails?.token;
      setBusinessTokenEdit(false);
    }
    const payload = {
      name: accountDetails?.businessName,
      token: accountDetails?.token,
    };
    updateBMdetails(payload, false);
  };

  const getChangedName = e => {
    seteditedDetails({ ...editedDetails, businessName: e?.target?.value });
  };

  const getChangedToken = e => {
    seteditedDetails({ ...editedDetails, token: e?.target?.value });
  };

  async function updateBMdetails(payload, isDelete) {
    try {
      const bmResponse = await AdminService.updateBmDetails(
        userAccessToken,
        username,
        payload,
        accountId
      );
      if (isDelete) {
        handleBackClick();
        setShowDeboardModal(false);
      } else {
        setAccountDetails({ ...accountDetails });
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const onClickOfDeboard = () => {
    setShowDeboardModal(true);
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeboardModal(false);
  };

  const onDeleteContinue = () => {
    const payload = {
      is_active: false,
    };
    updateBMdetails(payload, true);
  };

  const Cell = ({ label, status, nextSync }) => {
    return (
      <div className="label_container">
        <div className="label_name sync-val">{label}</div>
        <div className="label_value">
          {status !== 'SUCCESS' && <i className="eva  eva-alert-triangle yellow"></i>}
          {status === 'SUCCESS' && <i className="eva  eva-checkmark-circle-2"></i>}
          {status} | {t('admin.bm.details.next.sync')} {nextSync}
        </div>
      </div>
    );
  };

  const UsusgeCell = ({ label, result }) => {
    return (
      <div className="label_container">
        <div className="label_name">{label}</div>
        {!startDate && !endDate ? <div className="label_value">0/0</div> :<div className="label_value">{result}</div>}
      </div>
    );
  };

  const onStartDateChange = val => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3]);
      setStartDate(new Date(val));
      setEndDateDisable(false);
      setEndDate(null);
    } else {
      setFreq(freq);
      setStartDate(val);
      setEndDate(null);
      setEndDateDisable(true);
    }
  };

  const onEndDateChange = val => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3]);
      setEndDate(new Date(val));
      handleDateRange([new Date(startDate), new Date(val)]);
    } else {
      setFreq(freq);
      setEndDate(val);
    }
  };

  const handleSelect = freqency => {
    setFreq(freqency);
    if(freqency.value !== 'custom') {
      setEndDateDisable(false);
      handleDateRange(freqency.value);
    } else {
      setEndDateDisable(true);
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleDownloadSSClick = () => {
    const icon = document.querySelector(".download-icon");
    icon.classList.add("active");
    
    var testdiv = document.getElementById("snapshot-container");
    html2canvas(testdiv, {
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,          // There is no deviation from the top so there is no need to modify
        backgroundColor: 'white',
        allowTaint: true,
        useCORS: true
    }).then(canvas => {
        const image = canvas.toDataURL('image/jpeg', 1.0);
        const doc = new jsPdf('p', 'px', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const widthRatio = pageWidth / canvas.width;
        const heightRatio = pageHeight / canvas.height;
        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

        const canvasWidth = canvas.width * ratio;
        const canvasHeight = canvas.height * ratio;

        const marginX = (pageWidth - canvasWidth) / 2;
        const marginY = (pageHeight - canvasHeight) / 2;

        doc.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
        doc.save(`account-details.pdf`);
        icon.classList.remove("active");

    });

}

  return (
    <section>
      <div className="business_account_details">
        <div className="heading-btn-container">
          <div className="header-holder">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('admin.bm.details.back')}
            </button>
          </div>
          <DownloadIcon className='download-icon'/>
                <button className='download-snapshot' onClick={() => handleDownloadSSClick()}>
                    <i className="eva eva-camera-outline"></i>
                    {t('download.snapshot.button.label')}
                </button>
        </div>
        <div className="account-details-container">
          <div className="details-header">
            <h3>{t('admin.bm.details.bmId')}:&nbsp;</h3>
            <span>{accountId}</span>
          </div>
          <div className="account-details">
            <div className="business_name">{t('admin.bm.details.name')}</div>
            <div className="input-change">
              <input
                type={'text'}
                className="rs-input"
                defaultValue={accountDetails?.businessName}
                disabled={!businessNameEdit}
                onChange={getChangedName}
              />
              <Button appearance="link">
                {!businessNameEdit && <EditIcon onClick={() => onClickOfEdit('1')} />}
                {businessNameEdit && <SaveIcon onClick={() => onClickOfSave('1')} />}
              </Button>
            </div>
            <div className="business_name">{t('admin.bm.details.token')}</div>
            <div className="input-change">
              <input
                type={'text'}
                className="rs-input"
                defaultValue={accountDetails?.token}
                disabled={!businessTokenEdit}
                onChange={getChangedToken}
              />
              <Button appearance="link">
                {!businessTokenEdit && <EditIcon onClick={() => onClickOfEdit('2')} />}
                {businessTokenEdit && <SaveIcon onClick={() => onClickOfSave('2')} />}
              </Button>
            </div>
            <div className="diagnostics_container diagnostics_underline">
              <div className="diagnostics-header">{t('admin.bm.details.diagnostics')}</div>
              <div className="diagnostics_separator">
                <div className="separator_one">
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.active.owned')}</div>
                    <div className="label_value">
                      <span className="value-separator">{accountDetails?.activeOwnedAccounts}/{accountDetails?.ownedAccountSync?.ownedAdAccountsCount}</span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 1);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.active.client')}</div>
                    <div className="label_value">
                      <span className="value-separator">
                      {accountDetails?.acitveClientAccounts}/{accountDetails?.clientAccountSync?.clientAdAccountsCount}
                      </span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 2);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.total.users')}</div>
                    <div className="label_value">
                      <span className="value-separator">
                        {accountDetails?.totalBusinessUsers}/{accountDetails?.totalSignedUpUsers}
                      </span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 3);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="separator_two"></div>
                <div className="separator_one">
                  {diagnosticsDetails?.map(res => {
                    return (
                      <Cell label={res?.label} status={res?.status} nextSync={res?.nextSync} />
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="date_range_container">
              <div className="date-usage">
                <div className="c-dropdown-country">
                  <Dropdown
                    className="user-select"
                    heading={t('admin.ac.details.freq')}
                    options={predefinedRanges}
                    placeholder={t('admin.ac.select.freq')}
                    tooltipIndicator={false}
                    isImportant={false}
                    value={freq}
                    onSelect={handleSelect}
                  />
                </div>
                <div className='date_pickers'>
                <div className="business_name">{t('admin.bm.details.select.date.range')}</div>
                <div className="bottom-section">
                  <InputGroup>
                    <DatePicker
                      id="start-date"
                      disabled={startDateDisable}
                      format="dd-MM-yyyy"
                      value={startDate}
                      onChange={onStartDateChange}
                      disabledDate={allowedRange(new Date('04-01-2022'), new Date())}
                      placeholder={t('report.wrapper.start.date')}
                      oneTap
                    />
                    <InputGroup.Addon>to</InputGroup.Addon>
                    <DatePicker
                      id="end-date"
                      disabled={endDateDisable}
                      format="dd-MM-yyyy"
                      value={endDate}
                      onChange={onEndDateChange}
                      disabledDate={allowedRange(startDate, new Date())}
                      placeholder={t('report.wrapper.end.date')}
                      oneTap
                    />
                  </InputGroup>
                </div>
                </div>
              </div>
            </div>

            <div className="diagnostics_container usage_block">
              <div className="diagnostics-header">
                <div>{t('admin.bm.details.usuage')}</div>
                <div>{t('admin.bm.details.req')}</div>
              </div>
              <div className="diagnostics_separator">
                <div className="separator_one">
                  {usuageData?.map(res => {
                    return <UsusgeCell label={res?.label} result={res?.result} />;
                  })}
                </div>
              </div>
            </div>
            <button className="step-back" onClick={onClickOfDeboard}>
              {t('admin.bm.details.deboard')}
            </button>
          </div>
        </div>
        <div id='snapshot-container'>
        <div className="account-details-container">
          <div className="details-header">
            <h3>{t('admin.bm.details.bmId')}:&nbsp;</h3>
            <span>{accountId}</span>
          </div>
          <div className="account-details">
            <div className="business_name">{t('admin.bm.details.name')}</div>
            <div className="input-change">
              <input
                type={'text'}
                className="rs-input"
                defaultValue={accountDetails?.businessName}
                disabled={!businessNameEdit}
                onChange={getChangedName}
              />
              <Button appearance="link">
                {!businessNameEdit && <EditIcon onClick={() => onClickOfEdit('1')} />}
                {businessNameEdit && <SaveIcon onClick={() => onClickOfSave('1')} />}
              </Button>
            </div>
            <div className="business_name">{t('admin.bm.details.token')}</div>
            <div className="input-change">
              <input
                type={'text'}
                className="rs-input"
                defaultValue={accountDetails?.token}
                disabled={!businessTokenEdit}
                onChange={getChangedToken}
              />
              <Button appearance="link">
                {!businessTokenEdit && <EditIcon onClick={() => onClickOfEdit('2')} />}
                {businessTokenEdit && <SaveIcon onClick={() => onClickOfSave('2')} />}
              </Button>
            </div>
            <div className="diagnostics_container diagnostics_underline">
              <div className="diagnostics-header">{t('admin.bm.details.diagnostics')}</div>
              <div className="diagnostics_separator">
                <div className="separator_one">
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.active.owned')}</div>
                    <div className="label_value">
                      <span className="value-separator">{accountDetails?.activeOwnedAccounts}/{accountDetails?.ownedAccountSync?.ownedAdAccountsCount}</span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 1);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.active.client')}</div>
                    <div className="label_value">
                      <span className="value-separator">
                        {accountDetails?.acitveClientAccounts}/{accountDetails?.clientAccountSync?.clientAdAccountsCount}
                      </span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 2);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="label_container">
                    <div className="label_name">{t('admin.bm.details.total.users')}</div>
                    <div className="label_value">
                      <span className="value-separator">
                        {accountDetails?.totalBusinessUsers}/{accountDetails?.totalSignedUpUsers}
                      </span>
                      <span className="view-details">
                        <i className="eva  eva-arrow-forward-outline"></i>
                        <ActionLink
                          anchor={true}
                          value={t('admin.bm.details.view')}
                          handleClick={e => {
                            onViewAccounts(e, 3);
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="separator_two"></div>
                <div className="separator_one">
                  {diagnosticsDetails?.map(res => {
                    return (
                      <Cell label={res?.label} status={res?.status} nextSync={res?.nextSync} />
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="date_range_container">
              <div className="date-usage">
                <div className="c-dropdown-country">
                  <Dropdown
                    className="user-select"
                    heading={t('admin.ac.details.freq')}
                    options={predefinedRanges}
                    placeholder={t('admin.ac.select.freq')}
                    tooltipIndicator={false}
                    isImportant={false}
                    value={freq}
                    onSelect={handleSelect}
                  />
                </div>
                <div className='date_pickers'>
                <div className="business_name">{t('admin.bm.details.select.date.range')}</div>
                <div className="bottom-section">
                  <InputGroup>
                    <DatePicker
                      id="start-date"
                      disabled={startDateDisable}
                      format="dd-MM-yyyy"
                      value={startDate}
                      onChange={onStartDateChange}
                      disabledDate={allowedRange(new Date('04-01-2022'), new Date())}
                      placeholder={t('report.wrapper.start.date')}
                      oneTap
                    />
                    <InputGroup.Addon>to</InputGroup.Addon>
                    <DatePicker
                      id="end-date"
                      disabled={endDateDisable}
                      format="dd-MM-yyyy"
                      value={endDate}
                      onChange={onEndDateChange}
                      disabledDate={allowedRange(startDate, new Date())}
                      placeholder={t('report.wrapper.end.date')}
                      oneTap
                    />
                  </InputGroup>
                </div>
                </div>
              </div>
            </div>

            <div className="diagnostics_container usage_block">
              <div className="diagnostics-header">
                <div>{t('admin.bm.details.usuage')}</div>
                <div>{t('admin.bm.details.req')}</div>
              </div>
              <div className="diagnostics_separator">
                <div className="separator_one">
                  {usuageData?.map(res => {
                    return <UsusgeCell label={res?.label} result={res?.result} />;
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        {openSliderModal && (
          <ActiveAccounts
            insightDetails={openSliderModal}
            handleModalBackClick={handleOpenSliderModal}
            clickedView={viewDetails}
          />
        )}

        <div className="attr-delete">
          <ModalWindow
            className="fqa-modal--showanswer"
            isOpen={showDeboardModal}
            onRequestClose={handleOnCancel}
            heading={t('admin.bm.details.deboard.header')}
            ariaHideApp={false}
            appElement={document.getElementById('app')}
          >
            <p className="fqa-model-showanswer--message message-font">
              {t('admin.bm.details.deboard.subheader')}
            </p>
            <div className="fqa-model-pa--actions">
              <ActionLink
                anchor={true}
                value={t('reportTable.campaign.delete.cancel')}
                handleClick={handleOnCancel}
              />
              <Button
                className="fqa-model-pa--actions-confirm delete-button"
                onClick={onDeleteContinue}
              >
                {t('admin.bm.details.delete')}
              </Button>
            </div>
          </ModalWindow>
        </div>
      </div>
    </section>
  );
};

export default BusinessAccountDetails;
